export default __webpack_public_path__ + "static/media/phucthi.25f99720.png";